import store from './store'
import { AGlobalConfig } from 'kuaidong-api'
import { getModule, Module, Mutation, VuexModule, Action } from 'vuex-module-decorators'

import { MenuRole } from 'kuaidong-model'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'menu-role',
})
class MenuRoleModule extends VuexModule {
  menuRole: MenuRole | null = null
  menuRolePromise: Promise<MenuRole> | null = null

  @Mutation
  reset() {
    this.menuRole = null
    this.menuRolePromise = null
  }

  @Action
  async ensureMenuRoleConfigIsLoaded() {
    if (this.menuRolePromise === null) {
      this.loadMenuRole()
    }
    return this.menuRolePromise
  }

  @Action
  async loadMenuRole() {
    const menuRolePromise = AGlobalConfig.menuRoles()
    this.context.commit('setMenuRolePromise', menuRolePromise)
    this.context.commit('setMenuRole', await menuRolePromise)
  }

  @Mutation
  setMenuRolePromise(menuRolePromise: Promise<MenuRole>) {
    this.menuRolePromise = menuRolePromise
  }

  @Mutation
  setMenuRole(menuRole: MenuRole) {
    this.menuRole = menuRole
  }
}

export default getModule(MenuRoleModule)
